module.exports = __webpack_public_path__ + "static/media/camera-man@2x.bd384c3b.png";